import React, { Component } from 'react';
import styles from './ProblemDescription.scss';
import ReactMarkdown from 'react-markdown';

//displays  const current problem from state

class ProblemDescription extends Component {
  render() {
    let count = 0;
    const title = this.props.problem.description ? (
      <div className={styles.titleStyle}>{this.props.problem.title}</div>
    ) : (
      ''
    );
    // we display the Input Format, Output format in bold on the UI
    // this needs to be fixed
    const data =
      this.props.problem.title === 'Ledger Co' ? (
        <div
          className={styles['desc-style']}
          style={{ fontWeight: 'normal' }}
        >
          <ReactMarkdown>{this.props.problem.description}</ReactMarkdown>
        </div>
      ) : this.props.problem.description ? (
        this.props.problem.description.split('\n').map(function (line) {
          if (
            line.includes('Input format') ||
            line.includes('Output format') ||
            line.includes('Constraints')
          ) {
            return (
              <div
                key={count++}
                className={styles['desc-style']}
              >
                {line}
              </div>
            );
          } else if (
            line.includes('Input:') ||
            line.includes('Output:') ||
            line.includes('Explanation:')
          ) {
            // srb remove them later
            return (
              <div
                key={count++}
                className={styles['desc-style']}
              >
                {line}
              </div>
            );
          } else {
            return (
              <div
                key={count++}
                className={styles.contentstyle}
              >
                {line}
              </div>
            );
          }
        })
      ) : (
        'Please select a problem'
      );

    return (
      <div className={styles['c-problem-description__scrollbar']}>
        <div className={styles['c-problem-description']}>
          {title}
          {data}
        </div>
      </div>
    );
  }
}

export default ProblemDescription;
